import { getWeekdayCompareAPI } from "@/apis/apt-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { create } from "zustand"
import { RESOURCE_META } from "@/constants/resource-const"

export const weekdayCompareChartStore = create((set) => ({
  unit: "m³",
  series: [],

  apiGetWeekdayCompare: async ({ dong, ho, resource }) => {
    const { sido, kapt_code, ended_at: target_date } = aptSearchStore.getState().pickApt

    const { unit, datasets } = await getWeekdayCompareAPI({
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    })

    const weekdayLabels = [0, 1, 2, 3, 4, 5, 6]
    const series = [
      {
        id: "my",
        name: "my",
        type: "bar",
        data: weekdayLabels.map((_, idx) => datasets.my[idx] || 0),
        itemStyle: { color: RESOURCE_META[resource].colors.primary }
      },

      {
        id: "dong",
        name: "dong",
        type: "bar",
        data: weekdayLabels.map((_, idx) => datasets.dong_avg[idx] || 0),
        itemStyle: { color: "#94A3B8" }
      },

      {
        id: "apt",
        name: "apt",
        type: "bar",
        data: weekdayLabels.map((_, idx) => datasets.danji_avg[idx] || 0),
        itemStyle: { color: "#CBD5E1" }
      }
    ]

    set({ series, unit })
  },

  reset: () => {
    set({
      unit: "m³",
      series: []
    })
  }
}))
